import { BASE_URL_GOLANG } from 'common/config';
import { createAxiosInstance } from './axios-instance';

const axiosGolang = createAxiosInstance(BASE_URL_GOLANG);
export default axiosGolang;
